export var PageEnvironment;

(function (PageEnvironment) {
  PageEnvironment["prod"] = "prod";
  PageEnvironment["int"] = "int";
})(PageEnvironment || (PageEnvironment = {}));

export var PagePlatform;

(function (PagePlatform) {
  PagePlatform["web"] = "web";
  PagePlatform["app"] = "app";
})(PagePlatform || (PagePlatform = {}));